import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import uiSlice from 'store/modules/ui';

function SnackCloseButton({ snackKey = new Date().getTime() + Math.random() }) {
  const dispatch = useDispatch();

  const onCloseSnack = () => {
    dispatch(uiSlice.actions.closeSnackbar({ key: snackKey }));
  };

  return (
    <IconButton
      size="small"
      onClick={onCloseSnack}
      aria-label="Cerrar notificación"
      sx={{
        // El toast ahora es superficie del tema (blanca en claro): heredar el color del texto.
        color: 'inherit',
        opacity: 0.7,
        '&:hover': { opacity: 1 }
      }}>
      <Close fontSize="small" />
    </IconButton>
  );
}

SnackCloseButton.propTypes = {
  // Opcional: notistack pasa la clave del snack, y si no llega se genera una al vuelo.
  snackKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default SnackCloseButton;
